type Currency = 'USD';

export interface PaymentSchedule {
  last_charge: number;
  last_charge_currency: Currency;
  last_charge_date: string;
  next_charge: number;
  next_charge_currency: Currency;
  next_charge_date: string;
  plan_end_date: string;
  plan_start_date: string;
}
